import { Info } from '../realty/model/Info';
import StringFormatter from '../utility/StringFormatter';
import Fetcher from '../utility/Fetcher';

const REALTY_CODE_INFO_MESSAGE_KV_MAP: {
  [key: number]: string;
} = {
  '301': 'Matrikkelenheten finnes ikke',
  '402': 'Matrikkelenheten er historisk',
  '403': 'Matrikkelenheten er seksjonert',
  '404': 'Matrikkelenheten er ikke tinglyst',
  '405': 'Matrikkelenheten er sammenslått med matrikkel ',
  '406': 'Matrikkelenheten er ommatrikulert, ny matrikkel er ',
  '407': 'Matrikkelenheten er realsameie',
  '409': 'Leieavtale overført',
  '412': 'Borettsandelen er historisk',
  '415': 'Seksjonen er sammenslått med matrikkel ',
  '416': 'Seksjonen er fjernet',
  '417': 'Matrikkelenheten er jordsameie',
  '430': 'Matrikkelenheten er fradelt, ny matrikkel er '
};

const rc405 = 405;
const rc406 = 406;
const rc415 = 415;
const rc430 = 430;

export class AlertRuncomGenerator {
  public generate(info: Info): any {
    let rc: {
      settings: any;
      onConfirm?(isConfirm: boolean): void;
    };
    if (info && info.realtyCode) {
      const message: string = REALTY_CODE_INFO_MESSAGE_KV_MAP[info.realtyCode];
      rc = {
        settings: {
          title: message,
          text: '',
          type: 'info',
          showConfirmButton: true,
          allowEscapeKey: true,
          allowOutsideClick: true,
          animation: false,
          confirmButtonColor: '#5a059b',
          confirmButtonText: 'Ok',
          closeOnConfirm: true
        }
      };
      if ([rc405, rc406, rc415, rc430].indexOf(info.realtyCode) >= 0 && info.links.length > 0) {
        const key = info.links[0].key;
        rc.settings.text += StringFormatter.formatCadastreKey(key);
        rc.settings.text += '\n\nØnsker du å søke på denne matrikkelen?';
        rc.settings.showCancelButton = true;
        rc.settings.cancelButtonText = 'Nei';
        rc.settings.confirmButtonText = 'Ja';
        rc.onConfirm = (isConfirm: boolean) => {
          if (isConfirm) {
            // Without the timeout, a second swal appearing immediately after the
            // prompt swal will not be displayed due to a bug in swal.
            // Another approach is to kill the animation of the first swal (if it exists).
            // See: https://github.com/t4t5/sweetalert/issues/253
            const timeout = 500;
            setTimeout(() => {
              Fetcher.fetchModelData(key);
            }, timeout);
          }
        };
      }
    }
    return rc;
  }
}

export default new AlertRuncomGenerator();



/** WEBPACK FOOTER **
 ** ./src/utility/AlertRuncomGenerator.ts
 **/